import React, { useRef, useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import { Home } from "lucide-react";

const vocabulary = [
  {
    id: 21,
    lanna_text: "ᨶᩴ᩶ᩣᨶᩬᨦ",
    reading: "น้ำนอง",
    syllable_reading: "น้ำ-นอง",
    thai_word: "น้ำหลาก",
    meaning: "น้ำหลาก น้ำไหลมาท่วม หรือน้ำที่ไหลบ่าลงอย่างรวดเร็ว",
    letters: [
      { lanna: "ᨶ", thai: "น", sound: "นอ", type: "พยัญชนะ" },
      { lanna: "ᩣ", thai: "า", sound: "อา", type: "สระ" },
      { lanna: "ᨶ", thai: "น", sound: "นอ", type: "พยัญชนะ" },
      { lanna: "ᨦ", thai: "ง", sound: "งอ", type: "พยัญชนะ" },
    ],
  },
  {
    id: 22,
    lanna_text: "ᨡ᩠ᩅᩯᨦ",
    reading: "แขวง",
    syllable_reading: "แขวง",
    thai_word: "แขวง, เขต",
    meaning: "เขต แดน บริเวณที่กำหนด",
    letters: [
      { lanna: "ᨡ", thai: "ข", sound: "ขอ", type: "พยัญชนะ" },
      { lanna: "ᩅ", thai: "ว", sound: "วอ", type: "พยัญชนะ" },
      { lanna: "ᩯ", thai: "แ", sound: "แอ", type: "สระ" },
      { lanna: "ᨦ", thai: "ง", sound: "งอ", type: "พยัญชนะ" },
    ],
  },
  {
    id: 23,
    lanna_text: "ᨹᩯᩅᨷᩢ᩵ᩣᨸᩬ",
    reading: "แผวบ่าปอ",
    syllable_reading: "แผว-บ่า-ปอ",
    thai_word: "มิหนำซ้ำ",
    meaning: "มิหนำซ้ำ",
    letters: [
      { lanna: "ᨹ", thai: "ผ", sound: "ผอ", type: "พยัญชนะ" },
      { lanna: "ᩯ", thai: "แ", sound: "แอ", type: "สระ" },
      { lanna: "ᩅ", thai: "ว", sound: "วอ", type: "พยัญชนะ" },
      { lanna: "ᨷ", thai: "บ", sound: "บอ", type: "พยัญชนะ" },
      { lanna: "ᨸ", thai: "ป", sound: "ปอ", type: "พยัญชนะ" },
    ],
  },
  {
    id: 24,
    lanna_text: "ᨸᩯ᩠ᨦᩉ᩠ᨶ᩶ᩣᩃᩬᨠᨲᩣᩉᩖᩬᩥ᩶ᨾ",
    reading: "แป๋งหน้าลอกต๋าเหลื้อม",
    syllable_reading: "แป๋ง-หน้า-ลอก-ต๋า-เหลื้อม",
    thai_word: "ทำหน้าทะเล้น",
    meaning: "ทำหน้าทะเล้น ทำหน้าเป็น",
    letters: [
      { lanna: "ᨸ", thai: "ป", sound: "ปอ", type: "พยัญชนะ" },
      { lanna: "ᨦ", thai: "ง", sound: "งอ", type: "พยัญชนะ" },
      { lanna: "ᩉ", thai: "ห", sound: "หอ", type: "พยัญชนะ" },
      { lanna: "ᨶ", thai: "น", sound: "นอ", type: "พยัญชนะ" },
      { lanna: "ᩃ", thai: "ล", sound: "ลอ", type: "พยัญชนะ" },
      { lanna: "ᨠ", thai: "ก", sound: "กอ", type: "พยัญชนะ" },
    ],
  },
  {
    id: 25,
    lanna_text: "ᩋᩱ᩵ᨸᩢ᩠ᨶᨲᩣ᩠ᨿ",
    reading: "ไอ่ปันต๋าย",
    syllable_reading: "ไอ่-ปัน-ต๋าย",
    thai_word: "ไอ้พลันตาย",
    meaning: "คำด่า ไอ้พลันตาย",
    letters: [
      { lanna: "ᩋ", thai: "อ", sound: "ออ", type: "พยัญชนะ" },
      { lanna: "ᨸ", thai: "ป", sound: "ปอ", type: "พยัญชนะ" },
      { lanna: "ᨶ", thai: "น", sound: "นอ", type: "พยัญชนะ" },
      { lanna: "ᨲ", thai: "ต", sound: "ตอ", type: "พยัญชนะ" },
      { lanna: "ᨿ", thai: "ย", sound: "ยอ", type: "พยัญชนะ" },
    ],
  },
  {
    id: 26,
    lanna_text: "ᩉ᩠ᨶᩯ",
    reading: "แหน",
    syllable_reading: "แหน",
    thai_word: "แหน",
    meaning: "ชื่อไม้น้ำหลายชนิด ลอยอยู่ริมผิวน้ำ",
    letters: [
      { lanna: "ᩉ", thai: "ห", sound: "หอ", type: "พยัญชนะ" },
      { lanna: "ᨶ", thai: "น", sound: "นอ", type: "พยัญชนะ" },
      { lanna: "ᩯ", thai: "แ", sound: "แอ", type: "สระ" },
    ],
  },
  {
    id: 27,
    lanna_text: "ᨠᩡᩅᩩᨠᨠᩡᩅᩩ᩠ᨿ",
    reading: "กะวุกกะวุย",
    syllable_reading: "กะ-วุก-กะ-วุย",
    thai_word: "มอมแมม",
    meaning: "มอมแมม",
    letters: [
      { lanna: "ᨠ", thai: "ก", sound: "กอ", type: "พยัญชนะ" },
      { lanna: "ᩅ", thai: "ว", sound: "วอ", type: "พยัญชนะ" },
      { lanna: "ᨠ", thai: "ก", sound: "กอ", type: "พยัญชนะ" },
      { lanna: "ᨿ", thai: "ย", sound: "ยอ", type: "พยัญชนะ" },
    ],
  },
  {
    id: 28,
    lanna_text: "ᩈᩡᩃ᩠ᨿᨾᨷᩣ᩠ᨶ",
    reading: "สะเลียมบาน",
    syllable_reading: "สะ-เลียม-บาน",
    thai_word: "ไร้ประโยชน์",
    meaning: "สิ่งที่ไม่ต้องการ หรือไร้ประโยชน์",
    letters: [
      { lanna: "ᩈ", thai: "ส", sound: "สอ", type: "พยัญชนะ" },
      { lanna: "ᩃ", thai: "ล", sound: "ลอ", type: "พยัญชนะ" },
      { lanna: "ᨿ", thai: "ย", sound: "ยอ", type: "พยัญชนะ" },
      { lanna: "ᨾ", thai: "ม", sound: "มอ", type: "พยัญชนะ" },
      { lanna: "ᨷ", thai: "บ", sound: "บอ", type: "พยัญชนะ" },
      { lanna: "ᨶ", thai: "น", sound: "นอ", type: "พยัญชนะ" },
    ],
  },
  {
    id: 29,
    lanna_text: "ᨲᩦ᩶ᨠᩮᩢ᩶ᩣ",
    reading: "ตี้เก้า",
    syllable_reading: "ตี้-เก้า",
    thai_word: "ที่เก้า",
    meaning: "ลำดับที่เก้า",
    letters: [
      { lanna: "ᨲ", thai: "ต", sound: "ตอ", type: "พยัญชนะ" },
      { lanna: "ᨠ", thai: "ก", sound: "กอ", type: "พยัญชนะ" },
      { lanna: "ᩣ", thai: "า", sound: "อา", type: "สระ" },
    ],
  },
  {
    id: 30,
    lanna_text: "ᨧᩦ᩶ᨧᩡ",
    reading: "จี๊จ๊ะ",
    syllable_reading: "จี๊-จ๊ะ",
    thai_word: "แฉะ",
    meaning: "ลักษณะที่มีน้ำเยิ้ม หรือฉ่ำเฉอะแฉะ",
    letters: [
      { lanna: "ᨧ", thai: "จ", sound: "จอ", type: "พยัญชนะ" },
      { lanna: "ᨧ", thai: "จ", sound: "จอ", type: "พยัญชนะ" },
    ],
  },
  {
    id: 11,
    lanna_text: "ᩋᩬ᩵ᨿᨡᩮᩢ᩶ᩣᨠᩱ᩵",
    reading: "อ่อยเข้าไก่",
    syllable_reading: "อ่อย-เข้า-ไก่",
    thai_word: "ให้อาหารไก่",
    meaning: "ก. ให้อาหารไก่",
    letters: [
      { lanna: "ᩋ", thai: "อ", sound: "ออ", type: "พยัญชนะ" },
      { lanna: "ᩬ", thai: "อ", sound: "ออ", type: "สระ" },
      { lanna: "᩵", thai: "ไม้เอก", sound: "เอก", type: "วรรณยุกต์" },
      { lanna: "ᨿ", thai: "ย", sound: "ยอ", type: "พยัญชนะ (ตัวสะกด)" },
      { lanna: "ᨡ", thai: "ข", sound: "ขอ", type: "พยัญชนะ" },
      { lanna: "ᩮᩢ᩶ᩣ", thai: "เอา", sound: "เอา", type: "สระ" },
      { lanna: "ᨠ", thai: "ก", sound: "กอ", type: "พยัญชนะ" },
      { lanna: "ᩱ᩵", thai: "ไอ", sound: "ไอ", type: "สระ" },
    ],
  },
  {
    id: 12,
    lanna_text: "ᨷᩮᩢᩣᨲᩬᨦᩉ᩠ᨿᩬᨦ",
    reading: "เบาต๋องหยอง",
    syllable_reading: "เบา-ต๋อง-หยอง",
    thai_word: "เบาหวิว",
    meaning: "ลักษณะสิ่งของขนาดกลางที่เบา",
    letters: [
      { lanna: "ᨷ", thai: "บ", sound: "บอ", type: "พยัญชนะ" },
      { lanna: "ᩮᩢᩣ", thai: "เอา", sound: "เอา", type: "สระ" },
      { lanna: "ᨲ", thai: "ต", sound: "ตอ", type: "พยัญชนะ" },
      { lanna: "ᩬ", thai: "อ", sound: "ออ", type: "สระ" },
      { lanna: "ᨦ", thai: "ง", sound: "งอ", type: "พยัญชนะ (ตัวสะกด)" },
      { lanna: "ᩉ", thai: "ห", sound: "หอ", type: "พยัญชนะ (อักษรนำ)" },
      { lanna: "᩠ᨿ", thai: "ย", sound: "ยอ", type: "พยัญชนะ" },
      { lanna: "ᩬ", thai: "อ", sound: "ออ", type: "สระ" },
      { lanna: "ᨦ", thai: "ง", sound: "งอ", type: "พยัญชนะ (ตัวสะกด)" },
    ],
  },
  {
    id: 13,
    lanna_text: "ᨠᩥ᩠ᨶᨲᩧ᩠ᨠ†",
    reading: "กิ๋นตึกๆ",
    syllable_reading: "กิ๋น-ตึก-ตึก",
    thai_word: "กินเรื่อยๆ",
    meaning: "ก. กินเรื่อยๆ",
    letters: [
      { lanna: "ᨠ", thai: "ก", sound: "กอ", type: "พยัญชนะ" },
      { lanna: "ᩥ", thai: "อิ", sound: "อิ", type: "สระ" },
      { lanna: "᩠ᨶ", thai: "น", sound: "นอ", type: "พยัญชนะ (ตัวสะกด)" },
      { lanna: "ᨲ", thai: "ต", sound: "ตอ", type: "พยัญชนะ" },
      { lanna: "ᩧ", thai: "อึ", sound: "อึ", type: "สระ" },
      { lanna: "᩠ᨠ", thai: "ก", sound: "กอ", type: "พยัญชนะ (ตัวสะกด)" },
      { lanna: "†", thai: "ๆ", sound: "ซ้ำคำ", type: "เครื่องหมาย" },
    ],
  },
  {
    id: 14,
    lanna_text: "ᩉᩪ",
    reading: "หู",
    syllable_reading: "หู",
    thai_word: "หู",
    meaning: "น. อวัยวะของคนและสัตว์ มีไว้ฟังเสียง",
    letters: [
      { lanna: "ᩉ", thai: "ห", sound: "หอ", type: "พยัญชนะ" },
      { lanna: "ᩪ", thai: "อู", sound: "อู", type: "สระ" },
    ],
  },
  {
    id: 15,
    lanna_text: "ᨡᩦ᩶ᨲᩧ᩠ᨠᨸᩯ᩠ᨷ",
    reading: "ขี้ตึกแป๊บ",
    syllable_reading: "ขี้-ตึก-แป๊บ",
    thai_word: "พยาธิตัวตืด",
    meaning: "น. พยาธิตัวแบน หรือพยาธิตัวตืดที่อยู่ในลำไส้",
    letters: [
      { lanna: "ᨡ", thai: "ข", sound: "ขอ", type: "พยัญชนะ" },
      { lanna: "ᩦ᩶", thai: "อี", sound: "อี", type: "สระ" },
      { lanna: "ᨲ", thai: "ต", sound: "ตอ", type: "พยัญชนะ" },
      { lanna: "ᩧ", thai: "อึ", sound: "อึ", type: "สระ" },
      { lanna: "᩠ᨠ", thai: "ก", sound: "กอ", type: "พยัญชนะ (ตัวสะกด)" },
      { lanna: "ᨸ", thai: "ป", sound: "ปอ", type: "พยัญชนะ" },
      { lanna: "ᩯ", thai: "แอ", sound: "แอ", type: "สระ" },
      { lanna: "᩠ᨷ", thai: "บ", sound: "บอ", type: "พยัญชนะ (ตัวสะกด)" },
    ],
  },
  {
    id: 16,
    lanna_text: "ᩃᩡ",
    reading: "ละ",
    syllable_reading: "ละ",
    thai_word: "ทิ้ง",
    meaning: "ก. ทิ้ง, ปล่อย, หย่าร้าง",
    letters: [
      { lanna: "ᩃ", thai: "ล", sound: "ลอ", type: "พยัญชนะ" },
      { lanna: "ᩡ", thai: "อะ", sound: "อะ", type: "สระ" },
    ],
  },
  {
    id: 17,
    lanna_text: "ᩉ᩠ᨶ᩶ᩣᨦᩬᨣᩬᩉᩢ᩠ᨠ",
    reading: "หน้างอคอหัก",
    syllable_reading: "หน้า-งอ-คอ-หัก",
    thai_word: "หน้างอ",
    meaning: "ว. หน้างอก๊อกง๊อก (อารมณ์บูดบึ้ง)",
    letters: [
      { lanna: "ᩉ", thai: "ห", sound: "หอ", type: "พยัญชนะ (อักษรนำ)" },
      { lanna: "ᨶ", thai: "น", sound: "นอ", type: "พยัญชนะ" },
      { lanna: "᩶ᩣ", thai: "อา", sound: "อา", type: "สระ" },
      { lanna: "ᨦ", thai: "ง", sound: "งอ", type: "พยัญชนะ" },
      { lanna: "ᩬ", thai: "อ", sound: "ออ", type: "สระ" },
      { lanna: "ᨣ", thai: "ค", sound: "คอ", type: "พยัญชนะ" },
      { lanna: "ᩬ", thai: "อ", sound: "ออ", type: "สระ" },
      { lanna: "ᩉ", thai: "ห", sound: "หอ", type: "พยัญชนะ" },
      { lanna: "ᩢ", thai: "อะ", sound: "อะ (ไม้หันอากาศ)", type: "สระ" },
      { lanna: "᩠ᨠ", thai: "ก", sound: "กอ", type: "พยัญชนะ (ตัวสะกด)" },
    ],
  },
  {
    id: 18,
    lanna_text: "ᨷᩫ᩵ᨾᩰᨡ᩵",
    reading: "บ่มโข่",
    syllable_reading: "บ่ม-โข่",
    thai_word: "หมกตัว",
    meaning: "ก. แทรกอยู่ในกองหยากเยื่อ",
    letters: [
      { lanna: "ᨷ", thai: "บ", sound: "บอ", type: "พยัญชนะ" },
      { lanna: "ᩫ᩵", thai: "โอะ", sound: "โอะ", type: "สระ" },
      { lanna: "ᨾ", thai: "ม", sound: "มอ", type: "พยัญชนะ (ตัวสะกด)" },
      { lanna: "ᩰ", thai: "โอ", sound: "โอ", type: "สระ" },
      { lanna: "ᨡ", thai: "ข", sound: "ขอ", type: "พยัญชนะ" },
      { lanna: "᩵", thai: "ไม้เอก", sound: "เอก", type: "วรรณยุกต์" },
    ],
  },
  {
    id: 19,
    lanna_text: "ᨧᩩ",
    reading: "จุ๊",
    syllable_reading: "จุ๊",
    thai_word: "สุมกัน",
    meaning: "ก. ตั้งไว้, รวมกันไว้, สุมกันไว้",
    letters: [
      { lanna: "ᨧ", thai: "จ", sound: "จอ", type: "พยัญชนะ" },
      { lanna: "ᩩ", thai: "อุ", sound: "อุ", type: "สระ" },
    ],
  },
  {
    id: 20,
    lanna_text: "ᩉᩖᩱ᩶",
    reading: "ไหล้",
    syllable_reading: "ไหล้",
    thai_word: "ป่า",
    meaning: "น. ป่า, ที่อยู่ของสัตว์ป่า",
    letters: [
      { lanna: "ᩉ", thai: "ห", sound: "หอ", type: "พยัญชนะ (อักษรนำ)" },
      { lanna: "ᩖ", thai: "ล", sound: "ลอ", type: "พยัญชนะ" },
      { lanna: "ᩱ᩶", thai: "ไอ", sound: "ไอ", type: "สระ" },
    ],
  },
];

export default function ScriptTracingGamePage() {
  const canvasRef = useRef(null);
  const containerRef = useRef(null);

  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [isDrawing, setIsDrawing] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const [penSize, setPenSize] = useState(12);
  const [guideMode, setGuideMode] = useState(true);

  const currentWord = vocabulary[currentWordIndex];

  const progress = useMemo(() => {
    return ((currentWordIndex + 1) / vocabulary.length) * 100;
  }, [currentWordIndex]);

  const setupCanvas = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const context = canvas.getContext("2d");
    const rect = canvas.getBoundingClientRect();
    const dpr = window.devicePixelRatio || 1;

    canvas.width = Math.round(rect.width * dpr);
    canvas.height = Math.round(rect.height * dpr);

    context.setTransform(dpr, 0, 0, dpr, 0, 0);
    context.lineCap = "round";
    context.lineJoin = "round";
    context.strokeStyle = "#1e293b";
    context.lineWidth = penSize;
  };

  useEffect(() => {
    setupCanvas();
    clearCanvas();

    const handleResize = () => {
      setupCanvas();
      clearCanvas();
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [currentWordIndex, penSize]);

  const clearCanvas = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const context = canvas.getContext("2d");
    const rect = canvas.getBoundingClientRect();

    context.clearRect(0, 0, rect.width, rect.height);
  };

  const getPoint = (e) => {
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();

    return {
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    };
  };

  const startDrawing = (e) => {
    e.preventDefault();

    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");
    const point = getPoint(e);

    context.beginPath();
    context.moveTo(point.x, point.y);
    context.lineTo(point.x, point.y);
    context.stroke();

    setIsDrawing(true);

    if (canvas.setPointerCapture) {
      canvas.setPointerCapture(e.pointerId);
    }
  };

  const draw = (e) => {
    if (!isDrawing) return;
    e.preventDefault();

    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");
    const point = getPoint(e);

    context.lineTo(point.x, point.y);
    context.stroke();
  };

  const stopDrawing = (e) => {
    if (!isDrawing) return;

    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");

    context.closePath();
    setIsDrawing(false);

    if (canvas.releasePointerCapture && e?.pointerId) {
      canvas.releasePointerCapture(e.pointerId);
    }
  };

  const handleFinish = () => {
    setShowResult(true);
  };

  const handleNextWord = () => {
    setShowResult(false);
    clearCanvas();
    setCurrentWordIndex((prev) => (prev + 1) % vocabulary.length);
  };

  const handlePrevWord = () => {
    setShowResult(false);
    clearCanvas();
    setCurrentWordIndex((prev) =>
      prev === 0 ? vocabulary.length - 1 : prev - 1
    );
  };

  const speakThai = () => {
    if (!window.speechSynthesis) return;

    const utterance = new SpeechSynthesisUtterance(currentWord.reading);
    utterance.lang = "th-TH";
    utterance.rate = 0.8;
    window.speechSynthesis.cancel();
    window.speechSynthesis.speak(utterance);
  };

  return (
    
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-sky-50 to-emerald-50 px-3 py-4 sm:px-6 sm:py-6 font-sans">
      <div className="fixed top-4 left-4 z-[999] flex gap-2">
      <Link
        to="/games"
        className="flex items-center justify-center w-12 h-12 bg-white/90 backdrop-blur-md rounded-full shadow-lg text-amber-800 hover:bg-white hover:scale-110 active:scale-95 transition-all border-2 border-amber-100"
        title="กลับหน้าเกม"
        onPointerDown={(e) => e.stopPropagation()}
      >
        <Home className="w-6 h-6" />
      </Link>
    </div>
      <div className="mx-auto w-full max-w-5xl">
        <header className="text-center mb-4 sm:mb-6">
          <div className="inline-flex items-center gap-2 bg-white/80 border border-amber-200 rounded-full px-4 py-2 shadow-sm mb-3">
            <span className="text-2xl">✏️</span>
            <span className="text-sm sm:text-base font-bold text-amber-700">
              เกมฝึกคัดอักษรล้านนา
            </span>
          </div>

          <h1 className="text-2xl sm:text-4xl font-extrabold text-slate-800">
            หัดคัดตั๋วเมือง
          </h1>

          <p className="text-sm sm:text-base text-slate-600 mt-2">
            ใช้นิ้ว ปากกา หรือเมาส์ ลากตามตัวอักษรล้านนา
          </p>
        </header>

        <section className="bg-white/90 rounded-3xl shadow-lg border border-white p-4 sm:p-5 mb-4">
          <div className="flex items-center justify-between gap-3 mb-2">
            <span className="text-sm sm:text-base font-bold text-slate-700">
              คำที่ {currentWordIndex + 1} / {vocabulary.length}
            </span>

            <span className="text-xs sm:text-sm font-bold text-blue-700 bg-blue-100 px-3 py-1 rounded-full">
              ฝึกเขียน
            </span>
          </div>

          <div className="w-full bg-slate-200 rounded-full h-3 sm:h-4 overflow-hidden">
            <div
              className="h-full bg-blue-500 rounded-full transition-all duration-300"
              style={{ width: `${progress}%` }}
            />
          </div>
        </section>

        <main className="grid grid-cols-1 lg:grid-cols-[1fr_320px] gap-4">
          <section className="bg-white rounded-3xl shadow-xl border border-slate-100 overflow-hidden">
            <div className="p-4 sm:p-5 border-b border-slate-100 bg-gradient-to-r from-amber-100 to-orange-100">
              <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3">
                <div>
                  <p className="text-sm font-bold text-slate-500 mb-1">
                    คำอ่าน
                  </p>
                  <h2 className="text-2xl sm:text-4xl font-extrabold text-slate-800 leading-tight">
                    {currentWord.reading}
                  </h2>
                  <p className="text-base sm:text-lg text-orange-700 font-bold mt-1">
                    {currentWord.syllable_reading}
                  </p>
                </div>

                <button
                  onClick={speakThai}
                  className="min-h-[48px] px-5 py-3 bg-white hover:bg-amber-50 text-amber-700 border border-amber-200 rounded-2xl font-bold shadow-sm transition"
                >
                  🔊 ฟังคำอ่าน
                </button>
              </div>
            </div>

            <div
              ref={containerRef}
              className="relative w-full bg-white overflow-hidden"
              style={{
                height: "clamp(300px, 58vw, 560px)",
                touchAction: "none",
              }}
            >
              {guideMode && (
                <div className="absolute inset-0 pointer-events-none opacity-25">
                  <div className="h-full flex flex-col justify-evenly px-4">
                    {Array.from({ length: 6 }).map((_, i) => (
                      <div
                        key={i}
                        className="border-b-2 border-dashed border-slate-400"
                      />
                    ))}
                  </div>
                </div>
              )}

              <div className="absolute top-4 left-4 z-10 pointer-events-none">
                <div className="bg-emerald-100 text-emerald-700 text-xs sm:text-sm font-bold px-3 py-1 rounded-full">
                  เริ่มลากตามตัวจาง ๆ
                </div>
              </div>

              <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none px-3">
                <span
                  className="text-slate-200 text-center break-words"
                  style={{
                    fontFamily: "'LannaTilok', 'Noto Sans Tai Tham', sans-serif",
                    fontSize: "clamp(62px, 17vw, 210px)",
                    lineHeight: "1.05",
                    maxWidth: "100%",
                    overflowWrap: "anywhere",
                  }}
                >
                  {currentWord.lanna_text}
                </span>
              </div>

              <canvas
                ref={canvasRef}
                className="absolute inset-0 w-full h-full cursor-crosshair"
                style={{ touchAction: "none" }}
                onPointerDown={startDrawing}
                onPointerMove={draw}
                onPointerUp={stopDrawing}
                onPointerCancel={stopDrawing}
                onPointerLeave={stopDrawing}
              />
            </div>

            <div className="p-4 sm:p-5 bg-slate-50 border-t border-slate-100">
              <div className="grid grid-cols-2 sm:flex sm:flex-wrap gap-3">
                <button
                  onClick={clearCanvas}
                  className="min-h-[54px] px-4 py-3 bg-slate-200 hover:bg-slate-300 text-slate-700 font-extrabold rounded-2xl transition"
                >
                  🧽 ลบเขียนใหม่
                </button>

                <button
                  onClick={() => setGuideMode((prev) => !prev)}
                  className="min-h-[54px] px-4 py-3 bg-purple-100 hover:bg-purple-200 text-purple-700 font-extrabold rounded-2xl transition"
                >
                  {guideMode ? "ปิดเส้นไกด์" : "เปิดเส้นไกด์"}
                </button>

                <button
                  onClick={handlePrevWord}
                  className="min-h-[54px] px-4 py-3 bg-white hover:bg-slate-100 text-slate-700 border border-slate-200 font-extrabold rounded-2xl transition"
                >
                  ← คำก่อนหน้า
                </button>

                <button
                  onClick={handleFinish}
                  className="min-h-[54px] px-4 py-3 bg-blue-600 hover:bg-blue-700 text-white font-extrabold rounded-2xl shadow-md transition col-span-2 sm:col-span-1"
                >
                  ✅ ดูคำตอบ
                </button>
              </div>

              <div className="mt-4 bg-white rounded-2xl p-4 border border-slate-200">
                <label className="block text-sm font-bold text-slate-600 mb-2">
                  ขนาดเส้นปากกา: {penSize}px
                </label>

                <input
                  type="range"
                  min="6"
                  max="24"
                  value={penSize}
                  onChange={(e) => setPenSize(Number(e.target.value))}
                  className="w-full"
                />

                <p className="text-xs text-slate-500 mt-2">
                  มือถือใช้นิ้วแนะนำ 14–18px | แท็บเล็ตใช้ปากกา 8–12px | PC ใช้เมาส์ 10–14px
                </p>
              </div>
            </div>
          </section>

          <aside className="space-y-4">
            <section className="bg-white rounded-3xl shadow-lg border border-slate-100 p-4">
              <h3 className="text-lg font-extrabold text-slate-800 mb-3">
                เทียบคำอ่าน
              </h3>

              <div className="space-y-3">
                <div className="bg-blue-50 rounded-2xl p-4 border border-blue-100">
                  <p className="text-xs font-bold text-blue-600 mb-1">
                    อักษรล้านนา
                  </p>
                  <div
                    className="text-blue-700 leading-tight break-words"
                    style={{
                      fontFamily:
                        "'LannaTilok', 'Noto Sans Tai Tham', sans-serif",
                      fontSize: "clamp(38px, 10vw, 72px)",
                      lineHeight: "1.05",
                      overflowWrap: "anywhere",
                    }}
                  >
                    {currentWord.lanna_text}
                  </div>
                </div>

                <div className="bg-amber-50 rounded-2xl p-4 border border-amber-100">
                  <p className="text-xs font-bold text-amber-700 mb-1">
                    อ่านว่า
                  </p>
                  <p className="text-2xl font-extrabold text-slate-800">
                    {currentWord.reading}
                  </p>
                </div>

                <div className="bg-emerald-50 rounded-2xl p-4 border border-emerald-100">
                  <p className="text-xs font-bold text-emerald-700 mb-1">
                    ภาษาไทยกลาง
                  </p>
                  <p className="text-xl font-extrabold text-slate-800">
                    {currentWord.thai_word}
                  </p>
                </div>
              </div>
            </section>

            <section className="bg-white rounded-3xl shadow-lg border border-slate-100 p-4">
              <h3 className="text-lg font-extrabold text-slate-800 mb-3">
                เทียบอักษรในคำนี้
              </h3>

              <div className="grid grid-cols-2 gap-3">
                {currentWord.letters.map((item, index) => (
                  <div
                    key={`${item.lanna}-${index}`}
                    className="rounded-2xl border border-slate-200 bg-slate-50 p-3 text-center"
                  >
                    <div
                      className="text-slate-800"
                      style={{
                        fontFamily:
                          "'LannaTilok', 'Noto Sans Tai Tham', sans-serif",
                        fontSize: "clamp(30px, 8vw, 52px)",
                        lineHeight: "1",
                      }}
                    >
                      {item.lanna}
                    </div>

                    <div className="text-2xl font-extrabold text-slate-800 mt-1">
                      {item.thai}
                    </div>

                    <div className="text-xs text-slate-500">
                      {item.sound}
                    </div>

                    <div className="text-[11px] font-bold text-blue-600 bg-blue-100 rounded-full mt-2 px-2 py-1">
                      {item.type}
                    </div>
                  </div>
                ))}
              </div>
            </section>
          </aside>
        </main>
      </div>

      {showResult && (
        <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-3xl p-5 sm:p-7 max-w-lg w-full text-center shadow-2xl">
            <div
              className="text-blue-600 mb-3 break-words"
              style={{
                fontFamily: "'LannaTilok', 'Noto Sans Tai Tham', sans-serif",
                fontSize: "clamp(52px, 15vw, 120px)",
                lineHeight: "1.05",
                overflowWrap: "anywhere",
              }}
            >
              {currentWord.lanna_text}
            </div>

            <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-800">
              อ่านว่า: {currentWord.reading}
            </h2>

            <p className="text-lg sm:text-xl text-orange-700 font-bold mt-2">
              {currentWord.syllable_reading}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-5 text-left">
              <div className="bg-amber-50 rounded-2xl p-4 border border-amber-100">
                <p className="text-xs font-bold text-amber-700 mb-1">
                  ภาษาไทยกลาง
                </p>
                <p className="text-xl font-extrabold text-slate-800">
                  {currentWord.thai_word}
                </p>
              </div>

              <div className="bg-emerald-50 rounded-2xl p-4 border border-emerald-100">
                <p className="text-xs font-bold text-emerald-700 mb-1">
                  ความหมาย
                </p>
                <p className="text-base font-bold text-slate-800">
                  {currentWord.meaning}
                </p>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-3 mt-6">
              <button
                onClick={() => {
                  setShowResult(false);
                  clearCanvas();
                }}
                className="min-h-[56px] py-3 bg-slate-200 hover:bg-slate-300 text-slate-700 text-base sm:text-lg font-extrabold rounded-2xl transition"
              >
                เขียนใหม่
              </button>

              <button
                onClick={handleNextWord}
                className="min-h-[56px] py-3 bg-green-500 hover:bg-green-600 text-white text-base sm:text-lg font-extrabold rounded-2xl shadow-md transition"
              >
                คำต่อไป ➔
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}